/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  PerpetualMarketCore,
  PerpetualMarketCoreInterface
} from '../PerpetualMarketCore'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_priceFeedAddress',
        type: 'address'
      },
      {
        internalType: 'string',
        name: '_tokenName',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_tokenSymbol',
        type: 'string'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'productId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingRate',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'amountFundingPaidPerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingPaidPerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'poolReceived',
        type: 'int256'
      }
    ],
    name: 'FundingPayment',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'maxSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'hedgeRateOfReturnThreshold',
        type: 'uint256'
      }
    ],
    name: 'SetHedgeParams',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'perpFutureMaxFundingRate',
        type: 'int256'
      }
    ],
    name: 'SetPerpFutureMaxFundingRate',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'poolMarginRiskParam',
        type: 'int256'
      }
    ],
    name: 'SetPoolMarginRiskParam',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'squaredPerpFundingMultiplier',
        type: 'int256'
      }
    ],
    name: 'SetSquaredPerpFundingMultiplier',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeFeeRate',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'protocolFeeRate',
        type: 'int256'
      }
    ],
    name: 'SetTradeFeeRate',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'variance',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'underlyingPrice',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'timestamp',
        type: 'uint256'
      }
    ],
    name: 'VarianceUpdated',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'addLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'amountLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amountUsdc',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'futureWeight',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'isLong',
            type: 'bool'
          }
        ],
        internalType: 'struct NettingLib.CompleteParams',
        name: '_completeParams',
        type: 'tuple'
      }
    ],
    name: 'completeHedgingProcedure',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_depositor',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'mintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'executeFundingPayment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_deltaLiquidityAmount',
        type: 'int256'
      }
    ],
    name: 'getLPTokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getNettingInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'int256[2]',
            name: 'amountsUsdc',
            type: 'int256[2]'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          }
        ],
        internalType: 'struct NettingLib.Info',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getTokenAmountForHedging',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amountUsdc',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'futureWeight',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'isLong',
            type: 'bool'
          }
        ],
        internalType: 'struct NettingLib.CompleteParams',
        name: 'completeParams',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'getTradePrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int128[2]',
        name: 'amountAssets',
        type: 'int128[2]'
      }
    ],
    name: 'getTradePriceInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getUtilizationRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_depositor',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_initialFundingRate',
        type: 'int256'
      }
    ],
    name: 'initialize',
    outputs: [
      {
        internalType: 'uint256',
        name: 'mintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastHedgeSpotPrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'poolSnapshot',
    outputs: [
      {
        internalType: 'int128',
        name: 'futureBaseFundingRate',
        type: 'int128'
      },
      {
        internalType: 'int128',
        name: 'ethVariance',
        type: 'int128'
      },
      {
        internalType: 'int128',
        name: 'ethPrice',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: 'lastSnapshotTime',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'pools',
    outputs: [
      {
        internalType: 'uint128',
        name: 'amountLockedLiquidity',
        type: 'uint128'
      },
      {
        internalType: 'int128',
        name: 'positionPerpetuals',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: 'entryPrice',
        type: 'uint128'
      },
      {
        internalType: 'int256',
        name: 'amountFundingPaidPerPosition',
        type: 'int256'
      },
      {
        internalType: 'uint128',
        name: 'lastFundingPaymentTime',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rebalance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_minSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maxSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_hedgeRateOfReturnThreshold',
        type: 'uint256'
      }
    ],
    name: 'setHedgeParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_perpFutureMaxFundingRate',
        type: 'int256'
      }
    ],
    name: 'setPerpFutureMaxFundingRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_perpetualMarket',
        type: 'address'
      }
    ],
    name: 'setPerpetualMarket',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_poolMarginRiskParam',
        type: 'int256'
      }
    ],
    name: 'setPoolMarginRiskParam',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_squaredPerpFundingMultiplier',
        type: 'int256'
      }
    ],
    name: 'setSquaredPerpFundingMultiplier',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_tradeFeeRate',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_protocolFeeRate',
        type: 'int256'
      }
    ],
    name: 'setTradeFeeRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'updatePoolPosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: 'protocolFee',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'updatePoolSnapshot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_withdrawer',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_withdrawnAmount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: 'burnAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class PerpetualMarketCore__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _priceFeedAddress: string,
    _tokenName: string,
    _tokenSymbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PerpetualMarketCore> {
    return super.deploy(
      _priceFeedAddress,
      _tokenName,
      _tokenSymbol,
      overrides || {}
    ) as Promise<PerpetualMarketCore>
  }
  getDeployTransaction(
    _priceFeedAddress: string,
    _tokenName: string,
    _tokenSymbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceFeedAddress,
      _tokenName,
      _tokenSymbol,
      overrides || {}
    )
  }
  attach(address: string): PerpetualMarketCore {
    return super.attach(address) as PerpetualMarketCore
  }
  connect(signer: Signer): PerpetualMarketCore__factory {
    return super.connect(signer) as PerpetualMarketCore__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PerpetualMarketCoreInterface {
    return new utils.Interface(_abi) as PerpetualMarketCoreInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpetualMarketCore {
    return new Contract(address, _abi, signerOrProvider) as PerpetualMarketCore
  }
}
